<template>
    <div class="content-body customers-wrapper transaction-history">
        <b-row class="mb-4">
            <b-col class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <span class="feedbacks-tooltip">
                    Overview
                    <b-btn class="pl-0" variant="ghost" v-b-popover.hover="'Set a list of topics your loyalty member can choose when sending a feedback through their app'" title="">
                        <i class="ic-tooltip" id="topics"></i>
                    </b-btn>
                </span>
            </b-col>
            <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
              <div class="filter-wrapper">
                <b-form-select v-model="selectedBranch" :options="branchFilter" @input="filterBranch()" />
              </div>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker
                        :config="dateRangeConfig">
                    </datepicker>
                </b-input-group>
            </b-col>
        </b-row>
        <div class="sales-cards-overview mb-4">
            <b-row>
                <b-col>
                    <b-card>
                        <b-row no-gutters class="mb-4">
                            <b-col>
                                <img src="@/assets/images/snack.svg" alt="" class="mx-auto d-block">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4 class="amount">{{ snack.amount | toCurrency }}</h4>
                                <span class="amount-subheading">Amount</span>
                            </b-col>
                        </b-row>
                        <div class="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <h5>Count</h5>
                                    <span>{{ snack.count }}</span>
                                </b-col>
                                <b-col class="text-right">
                                    <h5>Avg. per Table</h5>
                                    <span>{{ snack.avg_per_table }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <b-row no-gutters class="mb-4">
                            <b-col>
                                <img src="@/assets/images/dinner.svg" alt="" class="mx-auto d-block">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4 class="amount">{{ dinner.amount | toCurrency }}</h4>
                                <span class="amount-subheading">Amount</span>
                            </b-col>
                        </b-row>
                        <div class="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <h5>Count</h5>
                                    <span>{{ dinner.count }}</span>
                                </b-col>
                                <b-col class="text-right">
                                    <h5>Avg. per Table</h5>
                                    <span>{{ dinner.avg_per_table }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <b-row no-gutters class="mb-4">
                            <b-col>
                                <img src="@/assets/images/lunch.svg" alt="" class="mx-auto d-block">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4 class="amount">{{ lunch.amount | toCurrency }}</h4>
                                <span class="amount-subheading">Amount</span>
                            </b-col>
                        </b-row>
                        <div class="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <h5>Count</h5>
                                    <span>{{ lunch.count }}</span>
                                </b-col>
                                <b-col class="text-right">
                                    <h5>Avg. per Table</h5>
                                    <span>{{ lunch.avg_per_table }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <b-row no-gutters class="mb-4">
                            <b-col>
                                <img src="@/assets/images/late-dinner.svg" alt="" class="mx-auto d-block">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4 class="amount">{{ lateDinner.amount | toCurrency }}</h4>
                                <span class="amount-subheading">Amount</span>
                            </b-col>
                        </b-row>
                        <div class="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <h5>Count</h5>
                                    <span>{{ lateDinner.count }}</span>
                                </b-col>
                                <b-col class="text-right">
                                    <h5>Avg. per Table</h5>
                                    <span>{{ lateDinner.avg_per_table }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card>
                        <b-row no-gutters class="mb-4">
                            <b-col>
                                <img src="@/assets/images/breakfast.svg" alt="" class="mx-auto d-block">
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4 class="amount">{{ breakfast.amount | toCurrency }}</h4>
                                <span class="amount-subheading">Amount</span>
                            </b-col>
                        </b-row>
                        <div class="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <h5>Count</h5>
                                    <span>{{ breakfast.count }}</span>
                                </b-col>
                                <b-col class="text-right">
                                    <h5>Avg. per Table</h5>
                                    <span>{{ breakfast.avg_per_table }}</span>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div class="sales-cards">
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Visit</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="visitTierTypeFields"
                            :items="visitTierType"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        >
                            <template slot="category" slot-scope="data"><span class="text-capitalize">{{ data.value }}</span></template>
                            <template slot="total_amount" slot-scope="data">{{ data.value | toCurrency }}</template>
                            <template slot="average" slot-scope="data">{{ getAverage(data.item.total_amount, data.item.total_count) | toCurrency }}</template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Branch Performance</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table 
                            :fields="branchPerformanceFields"
                            :items="branchPerformance"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        >
                            <template slot="amount" slot-scope="data">{{ data.value | toCurrency }}</template>
                            <template slot="average" slot-scope="data">{{ data.value | toCurrency }}</template>
                        </b-table>
                        <template slot="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <div class="mt-1">
                                        <span class="pagination-indicator">Showing {{ branchPerformancePagination.currentFirstItem }} to {{ branchPerformancePagination.currentLastItem }} of {{ branchPerformancePagination.maxPage}} pages</span>
                                    </div>
                                </b-col>
                                <b-col>
                                    <b-pagination
                                        hide-goto-end-buttons
                                        align="right"
                                        size="md"
                                        :total-rows="(branchPerformancePagination.totalPerPage > 0 ) ? branchPerformancePagination.maxPage * branchPerformancePagination.totalPerPage : 1"
                                        :limit="(branchPerformancePagination.totalPerPage > 0 ) ? 5 : 1"
                                        :per-page="branchPerformancePagination.totalPerPage"
                                        @change="branchPerformancePaginate"
                                        class="custom-pagination">
                                    </b-pagination>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">SKU Performance</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="skuPerformanceFields" 
                            :items="skuPerformance"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        ></b-table>
                        <template slot="footer">
                            <b-row no-gutters>
                                <b-col>
                                    <div class="mt-1">
                                        <span class="pagination-indicator">Showing {{ skuPerformancePagination.currentFirstItem }} to {{ skuPerformancePagination.currentLastItem }} of {{ skuPerformancePagination.maxPage}} pages</span>
                                    </div>
                                </b-col>
                                <b-col>
                                    <b-pagination
                                        hide-goto-end-buttons
                                        align="right"
                                        size="md"
                                        :total-rows="(skuPerformancePagination.totalPerPage > 0 ) ? skuPerformancePagination.maxPage * skuPerformancePagination.totalPerPage : 1"
                                        :limit="(skuPerformancePagination.totalPerPage > 0 ) ? 5 : 1"
                                        :per-page="skuPerformancePagination.totalPerPage"
                                        @change="skuPerformancePaginate"
                                        class="custom-pagination">
                                    </b-pagination>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col>
                    <b-card header-tag="header" footer-tag="footer">
                        <template slot="header">
                            <h6 class="mb-0 d-inline-block">Top Spending</h6>
                            <i class="ic-tooltip" id="help"></i>
                        </template>
                        <b-table
                            :fields="topSpendingVisitorFields"
                            :items="topSpendingVisitor"
                            show-empty
                            :empty-text="(loading) ? 'Loading data' : emptyText"
                        >
                            <template slot="customer_name" slot-scope="data"><span class="text-capitalize">{{ data.value }}</span></template>
                            <template slot="total_amount" slot-scope="data">{{ data.value | toCurrency }}</template>
                            <template slot="average" slot-scope="data">{{ data.value | toCurrency }}</template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";

const items = [];

export default {
    name: "sales",
    components: {
        Datepicker
    },
    data() {
        return {
            selectedBranch: "",
            branchOptions: [{ value: "all", text: "All Branches" }],
            items: items,
            searchPayload: {
                start_date: null,
                end_date: null,
                branch_code: null
            },
            emptyText: "No Records Found",
            branchPerformanceFields: [
                { key: "branch_name", label: "Branch Name" },
                { key: "transaction_count", label: "Transaction Count" },
                { key: "amount", label: "Total Amount" },
                { key: "average", label: "Average Spent" }
            ],
            visitTierTypeFields: [
                { key: "category", label: "Type" },
                { key: "total_count", label: "Transaction Count" },
                { key: "total_amount", label: "Total Amount" },
                { key: "average", label: "Average" }
            ],
            skuPerformanceFields: [
                // { key: "sku", label: "SKU" },
                { key: "name", label: "Product" },
                { key: "total_count", label: "Total Count" }
            ],
            topSpendingVisitorFields: [
                { key: "membership_id", label: "Card Number" },
                { key: "customer_name", label: "Name" },
                { key: "total_amount", label: "Total Spent (Sales Amount)" },
                {
                    key: "total_count",
                    label: "Total Visits (Transaction Count)"
                },
                { key: "average", label: "Average Spend per Visit" }
            ],
            range: null
        };
    },
    computed: {
        ...mapState("analytics", [
            "loading",
            "branchPerformance",
            "branchPerformancePagination",
            "branchFilter",
            "visitTierType",
            "skuPerformance",
            "skuPerformancePagination",
            "topCustomerVisit",
            "topSpendingVisitor",
            "dayPartReport",
            "snack",
            "breakfast",
            "dinner",
            "lunch",
            "lateDinner",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "message",
            "customer",
            "currentFirstItem",
            "currentLastItem",
            "currentPage",
            "totalPerPage"
        ]),
        dateRangeConfig: {
            get: function() {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // defaultDate: ["today", "today"],
                    onChange: function(selectedDates) {
                        _this.selectedDate(selectedDates);
                        _this.range = selectedDates;
                    },
                    maxDate: "today"
                };
            }
        },
        ...mapState("auth", {
            isLogin: state => state.login,
            user: state => state.user,
            enabledTopUps: state => state.enabledTopUps,
            merchant: state => state.merchant
        })
    },
    created() {
        this.getBranchPerformance(1);
        this.getBranchFilter(this.user.merchant_uuid);
        this.getVisitTierType();
        this.getSKUPerformance(1);
        this.getTopCustomerVisit();
        this.getTopSpendingVisitor();
        this.getDayPartReport();
        this.removeNoBranch();
    },
    filters: {
        toCurrency: function(value) {
            let formattedValue = Number.parseFloat(value).toFixed(2);
            return formattedValue
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    methods: {
        async getBranchPerformance(page) {
            let startDate =
                this.range != null
                    ? this.$moment(this.range[0]).format("YYYY-MM-DD")
                    : null;
            let endDate =
                this.range != null
                    ? this.$moment(this.range[1]).format("YYYY-MM-DD")
                    : null;

            let param = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_code:
                        this.selectedBranch == "" ? null : this.selectedBranch
                },

                page: page
            };

            await this.$store.dispatch("analytics/getBranchPerformance", param);
        },
        branchPerformancePaginate(page) {
            // if (this.searching) {
            //     return this.search(false, page);
            // }
            return this.getBranchPerformance(page);
        },
        selectedDate(value) {
            let range = {};

            if (value.length == 2) {
                range = this.getRange(value);

                this.filterDate(range, this.currentPage);
            }
        },
        getRange(value) {
            this.range = value;

            let range = {
                start: this.$moment(value[0]).format("YYYY-MM-DD"),
                end: this.$moment(value[1]).format("YYYY-MM-DD")
            };
            return range;
        },
        async filterDate(range, page = 1) {
            let param = {
                payload: {
                    start_date: range.start,
                    end_date: range.end,
                    branch_code:
                        this.selectedBranch == "" ? null : this.selectedBranch
                },
                page: page
            };

            await this.$store.dispatch("analytics/getBranchPerformance", param);
            await this.$store.dispatch("analytics/getVisitTierType", param);
            await this.$store.dispatch("analytics/getSKUPerformance", param);
            await this.$store.dispatch(
                "analytics/getTopSpendingVisitor",
                param
            );
            await this.$store.dispatch("analytics/getDayPartReport", param);
        },
        async filterBranch() {
            let startDate =
                this.range != null
                    ? this.$moment(this.range[0]).format("YYYY-MM-DD")
                    : null;
            let endDate =
                this.range != null
                    ? this.$moment(this.range[1]).format("YYYY-MM-DD")
                    : null;

            let param = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_code:
                        this.selectedBranch == "" ? null : this.selectedBranch
                },

                page: 1
            };

            await this.$store.dispatch("analytics/getBranchPerformance", param);
            await this.$store.dispatch("analytics/getVisitTierType", param);
            await this.$store.dispatch("analytics/getSKUPerformance", param);
            await this.$store.dispatch(
                "analytics/getTopSpendingVisitor",
                param
            );
            await this.$store.dispatch("analytics/getDayPartReport", param);
        },
        getBranchFilter(merchantUuid) {
            this.$store.dispatch("analytics/getBranchFilter", merchantUuid);
        },
        async getVisitTierType() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getVisitTierType", param);
        },
        async getSKUPerformance(page) {
            let startDate =
                this.range != null
                    ? this.$moment(this.range[0]).format("YYYY-MM-DD")
                    : null;
            let endDate =
                this.range != null
                    ? this.$moment(this.range[1]).format("YYYY-MM-DD")
                    : null;

            let param = {
                payload: {
                    start_date: startDate,
                    end_date: endDate,
                    branch_code:
                        this.selectedBranch == "" ? null : this.selectedBranch
                },

                page: page
            };

            await this.$store.dispatch("analytics/getSKUPerformance", param);
        },
        skuPerformancePaginate(page) {
            // if (this.searching) {
            //     return this.search(false, page);
            // }
            return this.getSKUPerformance(page);
        },
        async getTopCustomerVisit() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getTopCustomerVisit", param);
        },
        async getTopSpendingVisitor() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch(
                "analytics/getTopSpendingVisitor",
                param
            );
        },
        async getDayPartReport() {
            let param = {
                payload: this.searchPayload
            };
            await this.$store.dispatch("analytics/getDayPartReport", param);
        },
        removeNoBranch() {
            delete this.branchFilter[this.branchFilter.length - 1];
        },
        getAverage(totalAmount, totalCount) {
            let total = totalAmount / totalCount;
            if (Number.isNaN(total)) {
                return 0;
            } else {
                return total;
            }
        }
    }
};
</script>
